import React, { createContext, useState } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState();
  const [totalQty, setTotalQty] = useState([])
  const [totalValue, setTotalValue] = useState();
  const [laundryDetails, setLaundryDetails] = useState(false);
  const [laundrySummary, setLaundrySummary] = useState(false);
  const [laundryUpload, setLaundryUpload] = useState(false);
  const [laundryPayment, setLaundryPayment] = useState(false);
  const [laundryCartItems, setLaundryCartItems] = useState([]);

  const cartValue = {
    cartItems,
    setCartItems,
    subTotalValue,
    setSubTotalValue,
    laundryDetails,
    setLaundryDetails,
    laundrySummary,
    setLaundrySummary,
    laundryUpload,
    setLaundryUpload,
    laundryPayment,
    setLaundryPayment,
    laundryCartItems,
    setLaundryCartItems,
    totalValue,
    setTotalValue,
  };
  return (
    <CartContext.Provider value={cartValue}>{children}</CartContext.Provider>
  );
};
